import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  border-radius: 12px;
  border-bottom-left-radius: 0px;
  width: fit-content;
  max-width: 80%;
`;

export const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: ${(props) => props.theme.colors.greys.lighter};
  border-radius: 50%;
  flex-shrink: 0;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const typingAnimation = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.4;
  }
  30% {
    transform: translateY(-8px);
    opacity: 1;
  }
`;

export const TypingDots = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  span {
    width: 6px;
    height: 6px;
    background-color: #6c757d;
    border-radius: 50%;
    animation: ${typingAnimation} 1.4s infinite ease-in-out;

    &:nth-child(1) {
      animation-delay: -0.32s;
    }

    &:nth-child(2) {
      animation-delay: -0.16s;
    }

    &:nth-child(3) {
      animation-delay: 0s;
    }
  }
`;

export const Icon = styled.div`
  width: 24px;
  height: 24px;
  color: ${(props) => props.theme.colors.brand.primary};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;
